/**
 * Bounds a typed number field to what the database will accept.
 *
 * Several `projects` columns carry CHECK constraints, and an out-of-range value
 * gets all the way to the cloud save before Postgres rejects it — the user sees
 * a generic save failure with nothing to act on. `min`/`max` on the input
 * element does not prevent it: the browser will happily accept a typed or
 * pasted "-5" in a `type="number"` field.
 *
 * Blank returns null, which means "no value" — for an override column, the
 * section's own value.
 */
export function clampInput(raw: string, min: number, max = Number.MAX_SAFE_INTEGER): number | null {
  if (raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  return Math.min(max, Math.max(min, n));
}
